import firebase from "firebase/compat/app";
import {ObjectRef, PathRef} from "./Core";
import {AppCollection} from "./Principal";
import capitalize from "lodash/capitalize";
import {ProdutoVendido} from "./Produto";

export interface EventoObject {
  criado_em: firebase.firestore.Timestamp;
  atualizado_em: firebase.firestore.Timestamp;
  id: string;
  path: string;
  owner: string;
  principal: PathRef;
  tipo: string;
  data: firebase.firestore.Timestamp;
  descricao: string;
  notas: string;
  questionario: firebase.firestore.DocumentReference;

  proximo_contato: firebase.firestore.Timestamp;
  sem_proximo_contato: boolean;
  proximo_contato_notas: string;

  // evento fazendas !!eventoRequerProdutosUtilizados()
  produtos_utilizados?: ObjectRef[],
  
  // evento fazendas !!eventoRequerProdutosVendidos()
  produtos_vendidos?: ProdutoVendido[],
  produtos_vendidos_loja?: firebase.firestore.DocumentReference;
}

export const EventoDescricao = {
  APLICACAO_ASSISTIDA: 'Aplicação assistida',
  SEMEADURA: 'Semeadura',
  VENDA: 'Venda',
}

export const EventoTipo = {
  VISITA: 'Visita',
}



export const eventoRequerProdutosUtilizados = (principal: AppCollection, tipo: string|undefined, descricao: string|undefined): boolean => {
  if (principal !== 'fazendas')
    return false;

  if (!descricao || !tipo || tipo !== EventoTipo.VISITA)
    return false;

  return descricao === EventoDescricao.APLICACAO_ASSISTIDA || descricao === EventoDescricao.SEMEADURA;
}

export const eventoRequerProdutosVendidos = (principal: AppCollection, tipo: string|undefined, descricao: string|undefined): boolean => {
  if (principal !== 'fazendas')
    return false;

  if (!descricao || !tipo || tipo !== EventoTipo.VISITA)
    return false;

  return descricao === EventoDescricao.VENDA;
}


/*
Helper para obter a troca entre Próximo contato e Próxima aplicação
 */
export const getProximoContatoLabel = (
  principal: AppCollection,
  tipo: string|undefined,
  descricao: string|undefined, field: 'proximo_contato' | 'sem_proximo_contato' | 'proximo_contato_notas'): string => {
  let base = "próximo contato";

  if (eventoRequerProdutosUtilizados(principal, tipo, descricao) && descricao === EventoDescricao.APLICACAO_ASSISTIDA)
    base = "próxima aplicação";

  switch (field) {
    case "proximo_contato":
      return capitalize(base);
    case "sem_proximo_contato":
      return `Não agendar ${base}`;
    case "proximo_contato_notas":
      return `Notas ${base}`;
    default:
      throw new Error(`Unknow field: ${field}`)
  }
}